import { styled, Theme, Toolbar } from '@nexelem/deprecated-theme';

type StyledToolbarProps = {
  readonly withBreadcrumbs?: boolean;
};
export const StyledToolbar = styled(Toolbar, {
  shouldForwardProp: (prop: string) => !['withBreadcrumbs'].includes(prop),
})<StyledToolbarProps>(({ theme, withBreadcrumbs }) => {
  const typedTheme = theme as Theme;
  const basicStyles = {
    padding: typedTheme.spacing(0),
    minHeight: typedTheme.spacing(0),
    [theme.breakpoints.up('xs')]: {
      minHeight: typedTheme.spacing(0),
    },
    [theme.breakpoints.up('sm')]: {
      minHeight: typedTheme.spacing(0),
    },
  };
  if (withBreadcrumbs) {
    return {
      ...basicStyles,
      flexGrow: 1,
      paddingRight: typedTheme.spacing(10),
    };
  }
  return basicStyles;
});
